<h1 mat-dialog-title>Layout Settings</h1>
<div mat-dialog-content style="height: 700px">
  <mat-tab-group (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Details">
      <form class="standard-form">
        <mat-form-field>
          <mat-label>Layout Name</mat-label>
          <input matInput name="result.podLayout.name" [(ngModel)]="result.dodLayout.name" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Subscription</mat-label>
          <mat-select [(value)]="selectedSubscriptionId">
            <mat-option *ngFor="let subHeader of data.dodEndPoint.subHeaders" [value]="subHeader.subscriptionId">
              {{ subHeader.subscriptionName }} - {{ subHeader.organizationName }}
            </mat-option>

          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>File Type</mat-label>
          <mat-select name="result.podLayout.fileTypeId" [(ngModel)]="result.dodLayout.fileTypeId">
            <mat-option [value]="0">CSV</mat-option>
            <mat-option [value]="1">JSON</mat-option>
            <mat-option [value]="2">PARQUET</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
      <app-share-editor *ngIf="isOwner" [allowReadOnly]="true" [allowModify]="true" [(ngModel)]="shareState" [avaialbleSubscriptions]="data.dodEndPoint.subHeaders"></app-share-editor>
    </mat-tab>
    <mat-tab label="Output Destination">
      <br />
      <mat-card>
        <mat-card-title>
          <form class="standard-form">
            <mat-form-field>
              <mat-label>Destination Type</mat-label>
              <mat-select [(value)]="destinationId">
                <mat-option [value]="0">Email</mat-option>
                <mat-option [value]="1">SFtp</mat-option>
                <mat-option [value]="2">Azure Blob</mat-option>
                <mat-option [value]="3">AWS S3</mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </mat-card-title>
        <mat-card-content>
          <ng-container *ngIf="destinationId == 0">
            <form class="standard-form">
              <mat-form-field>
                <mat-label>Notification Email</mat-label>
                <input matInput name="results.dodLayout.notificationEmail" [(ngModel)]="result.dodLayout.notificationEmail" />
              </mat-form-field>
              <!--<mat-form-field>
                <mat-label>Email Address</mat-label>
                <input matInput name="emailConfig.emailAddress" [(ngModel)]="emailConfig.emailAddress" />
              </mat-form-field>-->
            </form>
          </ng-container>
          <ng-container *ngIf="destinationId == 1">
            <form class="standard-form">
              <mat-form-field>
                <mat-label>Notification Email</mat-label>
                <input matInput name="results.dodLayout.notificationEmail" [(ngModel)]="result.dodLayout.notificationEmail" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Host</mat-label>
                <input matInput name="sftpConfig.host" [(ngModel)]="sftpConfig.host" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Port</mat-label>
                <input matInput type="number" name="sftpConfig.port" [(ngModel)]="sftpConfig.port" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Username</mat-label>
                <input matInput name="sftpConfig.userName" [(ngModel)]="sftpConfig.userName" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Password</mat-label>
                <input matInput name="sftpConfig.password" [(ngModel)]="sftpConfig.password" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Remote Path</mat-label>
                <input matInput name="sftpConfig.path" [(ngModel)]="sftpConfig.path" />
              </mat-form-field>
            </form>
          </ng-container>
          <ng-container *ngIf="destinationId == 2">
            <form class="standard-form">
              <mat-form-field>
                <mat-label>Notification Email</mat-label>
                <input matInput name="results.dodLayout.notificationEmail" [(ngModel)]="result.dodLayout.notificationEmail" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Connection String</mat-label>
                <input matInput name="azureConfig.connectionString" [(ngModel)]="azureConfig.connectionString" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Container</mat-label>
                <input matInput name="azureConfig.containerName" [(ngModel)]="azureConfig.containerName" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Path</mat-label>
                <input matInput name="azureConfig.path" [(ngModel)]="azureConfig.path" />
              </mat-form-field>
            </form>
          </ng-container>
          <ng-container *ngIf="destinationId == 3">
            <form class="standard-form">
              <mat-form-field>
                <mat-label>Notification Email</mat-label>
                <input matInput name="results.dodLayout.notificationEmail" [(ngModel)]="result.dodLayout.notificationEmail" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Access Key</mat-label>
                <input matInput name="awsConfig.accessKey" [(ngModel)]="awsConfig.accessKey" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Secret Key</mat-label>
                <input matInput name="awsConfig.secretKey" [(ngModel)]="awsConfig.secretKey" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Region</mat-label>
                <input matInput name="awsConfig.region" [(ngModel)]="awsConfig.region" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Bucket</mat-label>
                <input matInput name="awsConfig.bucketName" [(ngModel)]="awsConfig.bucketName" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Path</mat-label>
                <input matInput name="awsConfig.path" [(ngModel)]="awsConfig.path" />
              </mat-form-field>
            </form>
          </ng-container>
        </mat-card-content>
      </mat-card>
    </mat-tab>
    <mat-tab label="Add. Data" *ngIf="dodEndPoint.subData && dodEndPoint.subData.length > 0">
      <br />
      <mat-card>
        <mat-card-title>Additional Data</mat-card-title>
        <mat-card-content>
          <ng-container *ngFor="let data of additionalData">
            <mat-checkbox [(ngModel)]="data.selected">{{data.title}}</mat-checkbox><br />
          </ng-container>
        </mat-card-content>
      </mat-card>
    </mat-tab>
    <mat-tab label="Dates" *ngIf="hasDates()">
      <br />
      <mat-card>
        <mat-card-title>Date Filtering</mat-card-title>
        <mat-card-content>
          <div class="container">
            <div class="row">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Date Range Type</mat-label>
                  <mat-select [(value)]="filterKeys.dateRangeType">
                    <mat-option [value]="0">Fixed Dates</mat-option>
                    <mat-option [value]="1">Range Dates</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4" *ngIf="filterKeys.dateRangeType == 0">
                <mat-form-field>
                  <mat-label>Start Date</mat-label>
                  <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="filterKeys.startDate">
                  <mat-hint>MM/DD/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #startDatePicker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="row" *ngIf="filterKeys.dateRangeType == 0">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>End Date</mat-label>
                  <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="filterKeys.endDate">
                  <mat-hint>MM/DD/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #endDatePicker ></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4" *ngIf="filterKeys.dateRangeType == 1">
                <mat-form-field>
                  <mat-label>Date Range</mat-label>
                  <mat-select [(value)]="filterKeys.dateRange">
                    <mat-option [value]="0">Last 7 Days</mat-option>
                    <mat-option [value]="1">This Month</mat-option>
                    <mat-option [value]="2">Last Month</mat-option>
                    <mat-option [value]="3">This Quarter</mat-option>
                    <mat-option [value]="4">Last Quarter</mat-option>
                    <mat-option [value]="5">This Year</mat-option>
                    <mat-option [value]="6">Last Year</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-tab>
    <mat-tab label="Companies" *ngIf="hasCompanies()">
      <div class="editor">
        <company-search [(ngModel)]="companySelectedValues" [fixedHeight]="500" [showSelected]="true"></company-search>
      </div>
    </mat-tab>
    <mat-tab label="Titles" *ngIf="hasTitles()">
      <div class="editor title-editor">
        <full-title-search [(ngModel)]="titleValues" [fixedHeight]="500"></full-title-search>
      </div>
    </mat-tab>
    <mat-tab label="Industries" *ngIf="hasIndustries()">
      <div class="editor">
        <industry-filter-editor [ngClass]="'filter-editor'" [(ngModel)]="filterKeys.industries"></industry-filter-editor>
      </div>
    </mat-tab>
    <mat-tab label="Occupations" *ngIf="hasOccupations()">
      <div class="editor">
        <occupation-filter-editor [ngClass]="'filter-editor'" [(ngModel)]="filterKeys.occupations"></occupation-filter-editor>
      </div>
    </mat-tab>
    <mat-tab label="Locations" *ngIf="hasLocations()">
      <div class="editor">
        <mat-radio-group [(ngModel)]="locationType">
          <mat-radio-button [value]="'CleanLocation'">Locations</mat-radio-button>
          &nbsp;&nbsp; <b>OR</b> &nbsp;&nbsp;
          <mat-radio-button [value]="'MetroGroup'">Metro Groups</mat-radio-button>
        </mat-radio-group>
        <ng-container *ngIf="locationType === 'CleanLocation'">
          <location-filter-editor [ngClass]="'filter-editor'" [(ngModel)]="filterKeys.locations"></location-filter-editor>
        </ng-container>
        <ng-container *ngIf="locationType === 'MetroGroup'">
          <metro-group-filter-editor [ngClass]="'filter-editor'" [(ngModel)]="filterKeys.metroGroups"></metro-group-filter-editor>
        </ng-container>
      </div>
    </mat-tab>
    <mat-tab label="Job Attributes" *ngIf="hasAttributes()">
      <div class="editor">
        <attribute-search [(ngModel)]="filterKeys.attributes" [fixedHeight]="500" [showSelected]="true"></attribute-search>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onSaveLayout()">Save Layout</button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>
</div>
